// @flow
import withDealerTitle from 'app/common/templates/CommonPageTemplate/withDealerTitle';
import CommonPageTemplate from 'app/common/templates/CommonPageTemplate/CommonPageTemplate';
import CommonPageTemplateE from 'app/common/templates/CommonPageTemplate/CommonPageTemplateE';

export default CommonPageTemplate;
export { withDealerTitle, CommonPageTemplateE };
